import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class FileViewerService {

  public sanitizedUrl!: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer,private snackbar: MatSnackBar) {}

  public openSnackBar(message: string, action: string = '') {
    if (!Swal.isVisible()){
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: message,
            backdrop: false,
            confirmButtonText: 'OK'
            // footer: '<a href="#">Why do I have this issue?</a>'
          }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.isConfirmed) {
              Swal.close();
            }
          });
        }
  }

  loadDocument(url: string): void {
    const fileName = this.getFileNameFromURL(url) ;;
    const fileExtension = url.split('.').pop()?.toLowerCase();

    const mimeTypes: { [key: string]: string } = {
      mp4: 'video/mp4',
      webm: 'video/webm',
      ogg: 'video/ogg',
    };
    const mimeType = mimeTypes[fileExtension];

    let content = '';

    if (['doc', 'docx', 'xls', 'xlsx'].includes(fileExtension)) {
      const officeViewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`;
      content = `<iframe src="${officeViewerUrl}" width="100%" height="100%" frameborder="0"></iframe>`;
    } else if (fileExtension === 'pdf') {
      content = `<iframe src="https://docs.google.com/viewer?url=${encodeURIComponent(url)}&embedded=true" width="100%" height="100%" frameborder="0" style="border:none; width:100vw; height:100vh;"></iframe>`;
    } else if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(fileExtension)) {
      content = `<img src="${url}" style="max-width:100%; height:auto; display:block; margin:auto;">`;
    } else if (['txt'].includes(fileExtension)) {
      content = `
        <pre id="fileContent" style="white-space: pre-wrap; word-wrap: break-word; font-family: Arial, sans-serif;">Loading...</pre>
        <script>
          fetch('${url}')
            .then(response => response.text())
            .then(data => {
              document.getElementById('fileContent').innerText = data;
            })
            .catch(() => {
              document.getElementById('fileContent').innerText = 'Failed to load text file.';
            });
        </script>
      `;
    } else if (mimeType) {
      content = `
        <video controls autoplay style="max-width:100%; max-height:100%; display:block; margin:auto;">
          <source src="${url}" type="${mimeType}">
          Your browser does not support the video tag.
        </video>`;
    } else {
      this.openSnackBar('File type not supported for viewing in the browser.');
      return;
    }

    const htmlContent = `
      <!DOCTYPE html>
      <html lang="en">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>${fileName}</title>
          <style>
            body { margin: 0; padding: 0; overflow: hidden; }
            iframe, img, video { width: 100vw; height: 100vh; }
          </style>
        </head>
        <body>
          ${content}
        </body>
      </html>
    `;

    // Create a Blob URL
    const blob = new Blob([htmlContent], { type: 'text/html' });
    const blobURL = URL.createObjectURL(blob);

    // Open a new tab and update the title explicitly
    const newTab = window.open(blobURL, '_blank');
    if (newTab) {
      newTab.onload = () => {
        newTab.document.title = fileName; // Update the title after loading
      };
    } else {
      this.openSnackBar('Failed to open a new tab. Please check your browser settings.');
      // alert('Failed to open a new tab. Please check your browser settings.');
    }
  }



  // Utility function to extract filename from URL
  private getFileNameFromURL(url: string): string {
    const decodedUrl = decodeURIComponent(url); // Decode any encoded URL
    return decodedUrl.substring(decodedUrl.lastIndexOf('/') + 1) || 'Document Viewer';
  }
}
